import styled from 'styled-components';
import { flexCenter } from '../../../../helpers/style-helpers';

export const MenuItemSC = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 24px;
  height: 52px;
  border-radius: 15px;
  padding-left: 16px;
  padding-right: 22px;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(24, 30, 52, 0.08), 0 2px 15px 0 rgba(51, 61, 108, 0.1);

  &:hover {
    .mi-name {
      opacity: 1;
    }
  }

  .mi-chevron {
    width: 7px;
    height: 11px;
    transform: rotate(-180deg);
    margin-left: auto;
  }

  .mi-name {
    transition: opacity 0.2s;
    font-weight: 600;
    opacity: 0.6;
  }

  .mi-icon {
    ${flexCenter}

    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`;
